import { render } from "./AddFromVideo.vue?vue&type=template&id=28e6f18f&scoped=true"
import script from "./AddFromVideo.vue?vue&type=script&lang=js"
export * from "./AddFromVideo.vue?vue&type=script&lang=js"

import "./AddFromVideo.vue?vue&type=style&index=0&id=28e6f18f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e6f18f"]])

export default __exports__